import React from 'react';
import {v4 as uuidv4} from 'uuid';
import CloseModal from '../../../libs/react-components-admin/modal/close-modal';
import FieldCondition from './field-condition';
import fieldService from '../../../services/field-service';
import SubSection from '../../../libs/react-components-admin/section/sub-section';

export default class FieldConditions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      model: props.model || [],
    };
  }

  updateModel(model) {
    this.setState(
      {model: model},
      () => this.props.onChange(this.state.model)
    );
  }

  addCondition() {
    const newCondition = {id: uuidv4(), name: 'My condition'};
    this.updateModel([...this.state.model, newCondition]);
    this.openModal(newCondition);
  }

  deleteCondition(id) {
    this.updateModel(this.state.model.filter(c => c.id !== id));
  }

  openModal(condition) {
    CloseModal.showModal(
      <FieldCondition fields={this.props.fields}
                      model={condition}
                      onChange={value => this.updateModel(this.state.model.map(c => c.id === value.id ? value : c))}/>,
      'modal-lg'
    );
  }

  render() {
    const hasNonStaticField = this.props.fields.some(f => !fieldService.isStaticFieldType(f.fieldType));
    return <SubSection title="Field conditions" className={this.props.className || ''}>
      <div className="form-text mb-3">Define here the conditions that can be used in the fields above, to show/hide certain fields</div>
      <ul className="list-group">
        {this.state.model.sort((a, b) => (a.name ||'').localeCompare(b.name || '')).map(condition => {
          return <li key={condition.id} className="list-group-item">
            <div className="row align-items-center">
              <div className="col">{condition.name}</div>
              <div className="col-auto">
                <button type="button"
                        className="btn btn-secondary btn-sm px-4"
                        onClick={() => this.openModal(condition)}>
                  Edit
                </button>
              </div>
              <div className="col-auto">
                <button type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => this.deleteCondition(condition.id)}>
                  <span className="material-icons align-middle" style={{fontSize: '1.1rem'}}>delete</span>
                </button>
              </div>
            </div>
          </li>;
        })}
        <li className="list-group-item">
          <div className="row">
            <div className="col">
              {!hasNonStaticField &&
              <div className="form-text text-warning">Please add at least one field before creating a condition</div>
              }
            </div>
            <div className="col-auto">
              <button type="button"
                      className="btn btn-success btn-sm"
                      onClick={() => this.addCondition()}
                      disabled={!hasNonStaticField}>
                {this.state.model.length === 0 ?
                  <span>Create condition</span> :
                  <span className="material-icons align-middle" style={{fontSize: '1.1rem'}}>add</span>
                }
              </button>
            </div>
          </div>
        </li>
      </ul>
    </SubSection>;
  }

}
